module.exports = __webpack_public_path__ + "static/img/解决方案-化工行业智能监管解决方案-周界入侵与违规停留.9525922a.png";